import { FetchState } from '../@core/fetch-state.types';
import { emptyState } from '../@core/fetch-state.utils';
import { SafeAny } from '../types/safe-any';

import { BaseClient, Client, Country, State } from './clients/clients.state.interface';
import { singleOrderDetails } from './orders/orders.model';
import { CANumberById, ICableAssemblyOrder, Quote } from './quotes/quotes.state.interface';

export const appStateKey = 'app';

export interface AppState {
  readonly loggedInUser: FetchState<SafeAny>;
  readonly activeUsers: FetchState<SafeAny>;
  readonly activeUsersTotalCount: number;
  readonly archivedUsers: FetchState<SafeAny>;
  readonly archivedUsersTotalCount: number;
  readonly fetchedUser: FetchState<SafeAny>;
  readonly fetchedUserRoles: FetchState<SafeAny>;
  readonly activeQuotes: FetchState<Quote[]>;
  readonly activeQuotesTotalCount: number;
  readonly archivedQuotes: FetchState<Quote[]>;
  readonly archivedQuotesTotalCount: number;
  readonly archivedUser: FetchState<SafeAny>;
  readonly unarchivedUser: FetchState<SafeAny>;
  readonly addedUser: FetchState<SafeAny>;
  readonly updatedUser: FetchState<SafeAny>;
  readonly changedPassword: FetchState<SafeAny>;
  readonly assignees: FetchState<SafeAny>;
  readonly customers: FetchState<SafeAny>;
  readonly statuses: FetchState<SafeAny>;
  readonly groups: FetchState<SafeAny>;
  readonly categories: FetchState<SafeAny>;
  readonly shippingMethods: FetchState<SafeAny>;
  readonly clients: FetchState<Client[]>;
  readonly clientsTotalCount: number;
  readonly addedClient: FetchState<BaseClient>;
  readonly loadedClient: FetchState<Client>;
  readonly updatedClient: FetchState<Client>;
  readonly duplicatedClient: FetchState<Client>;
  readonly countries: FetchState<Country[]>;
  readonly statesForAddress1: FetchState<State[]>;
  readonly statesForAddress2: FetchState<State[]>;
  readonly quotesShippingMethod: FetchState<SafeAny>;
  readonly caNumbers: FetchState<SafeAny[]>;
  readonly selectedCANumber: FetchState<CANumberById>;
  readonly itemProcesses: FetchState<SafeAny[]>;
  readonly selectedItemProcess: FetchState<SafeAny>;
  readonly createdQuote: FetchState<SafeAny>;
  readonly selectedQuote: FetchState<SafeAny>;
  readonly itemProcessesCategories: FetchState<SafeAny>;
  readonly savedNote: FetchState<SafeAny>;
  readonly myOrdersList: FetchState<singleOrderDetails[] | null>;
  readonly myOrdersListLength: FetchState<number | null>;
  readonly exportQuotesBundle: FetchState<SafeAny>;
  readonly archivedQuote: FetchState<Quote>;
  readonly unarchivedQuote: FetchState<Quote>;
  readonly deletedQuote: FetchState<string>;
  readonly createdOrder: FetchState<SafeAny>;
  readonly updatedQuote: FetchState<ICableAssemblyOrder>;
  readonly duplicatedQuote: FetchState<{ id: number }>;
  readonly updatedOrder: FetchState<singleOrderDetails>;
}

export const initialAppState: AppState = {
  loggedInUser: emptyState(),
  activeUsers: emptyState(),
  activeUsersTotalCount: 0,
  archivedUsers: emptyState(),
  archivedUsersTotalCount: 0,
  fetchedUser: emptyState(),
  fetchedUserRoles: emptyState(),
  activeQuotes: emptyState(),
  activeQuotesTotalCount: 0,
  archivedQuotes: emptyState(),
  archivedQuotesTotalCount: 0,
  archivedUser: emptyState(),
  unarchivedUser: emptyState(),
  addedUser: emptyState(),
  updatedUser: emptyState(),
  changedPassword: emptyState(),
  assignees: emptyState(),
  customers: emptyState(),
  statuses: emptyState(),
  groups: emptyState(),
  categories: emptyState(),
  shippingMethods: emptyState(),
  clients: emptyState(),
  clientsTotalCount: 0,
  addedClient: emptyState(),
  loadedClient: emptyState(),
  updatedClient: emptyState(),
  duplicatedClient: emptyState(),
  countries: emptyState(),
  statesForAddress1: emptyState(),
  statesForAddress2: emptyState(),
  quotesShippingMethod: emptyState(),
  caNumbers: emptyState(),
  selectedCANumber: emptyState(),
  itemProcesses: emptyState(),
  selectedItemProcess: emptyState(),
  createdQuote: emptyState(),
  selectedQuote: emptyState(),
  itemProcessesCategories: emptyState(),
  savedNote: emptyState(),
  myOrdersList: emptyState() || null,
  myOrdersListLength: emptyState() || null,
  exportQuotesBundle: emptyState(),
  archivedQuote: emptyState(),
  unarchivedQuote: emptyState(),
  deletedQuote: emptyState(),
  createdOrder: emptyState(),
  updatedQuote: emptyState(),
  duplicatedQuote: emptyState(),
  updatedOrder: emptyState(),
};
